
import { Component, Vue } from "vue-property-decorator";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/dist/sweetalert2.min.css";

@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    MyProfile: () => import("@/components/Jobs/Profile/MyProfile.vue")
  }
})
export default class ProfileJobs extends Vue {
  visible = false;

  beforeMount() {
    if (!this.$store.state.user.active) {
      Swal.fire(
        "Cuenta inactivada!",
        "La cuenta está inactiva, debes completar la activación para continuar.",
        "error"
      ).then((result: any) => {
        return ((window as any).location = "/crear-cuenta");
      });
    }

    this.visible = true;
  }
}
